/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Definition_LabelInputs */



/**
* | output |
* | --- |
* | "Definition" |
*
* @param {Tags_Manager_Definition_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_definition_label = /** @type {((inputs?: Tags_Manager_Definition_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Definition_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Definition")
	if (locale === "de") return /** @type {LocalizedString} */ ("Definition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Definizione")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Определение")
	if (locale === "es") return /** @type {LocalizedString} */ ("Definición")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("定义")
	if (locale === "ja") return /** @type {LocalizedString} */ ("意味")
	if (locale === "hi") return /** @type {LocalizedString} */ ("परिभाषा")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Definição")
	return /** @type {LocalizedString} */ ("Definition")
});